import React from "react";
import Header from "../../../../components/Header";
import FooterTwo from "../../../../components/Footer/index";
import ScrollToTop from "../../../../components/ScrollTop";
import Banner from "../../images/banners/nirf.webp";
import SideManu from "./sidebar";
import NIRFIMAGE from "./images/NIRF.webp";
import "@fortawesome/fontawesome-free/css/all.min.css";

const diploma_programs = () => {
  const nirfData = [
    {
      year: "NIRF 2024-2025",
      data: [
        { id: 1, name: "Engineering", code: "IR-E-C-17955" },
        { id: 2, name: "Overall", code: "IR-O-C-17955" },
        { id: 3, name: "Innovation", code: "IR-I-C-17955" },
        { id: 4, name: "SDG", code: "IR-B-C-17955" },
      ],
    },
    {
      year: "NIRF 2023-2024",
      data: [
        {
          id: 1,
          name: "Engineering ID",
          code: "IR–E–C–17955",
          // link: "uploads/NIRF/Engg_2024_Submitted_NIRF_23_24.pdf",
        },
        {
          id: 2,
          name: "Overall ID",
          code: "IR–O–C–17955",
          // link: "uploads/NIRF/Overall_Submitted_NIRF_23_24.pdf",
        },
      ],
    },
    {
      year: "NIRF 2022-2023",
      data: [
        {
          id: 1,
          name: "Engineering ID",
          code: "IR–E–C–17955",
          // link: "uploads/NIRF/AEC_Engg_22_2023.pdf",
        },
        {
          id: 2,
          name: "Overall ID",
          code: "IR–O–C–17955",
          // link: "uploads/NIRF/AEC_Overall_22_2023.pdf",
        },
      ],
    },
    {
      year: "NIRF 2021-2022",
      data: [
        {
          id: 1,
          name: "Engineering ID",
          code: "IR–E–C–17955",
          // link: "uploads/NIRF/AEC_Engg_2022.pdf",
        },
        {
          id: 2,
          name: "Overall ID",
          code: "IR–O–C–17955",
          // link: "uploads/NIRF/AEC_Overall_2022.pdf",
        },
      ],
    },
    {
      year: "NIRF 2020-2021",
      data: [
        {
          id: 1,
          name: "Engineering ID",
          code: "IR–E–C–17955",
          // link: "uploads/NIRF/AEC_NIRF2021_ENGINEERING.pdf",
        },
        {
          id: 2,
          name: "Overall ID",
          code: "IR–O–C–17955",
          // link: "uploads/NIRF/AEC_NIRF2021_OVERALL.pdf",
        },
      ],
    },
    {
      year: "NIRF 2019-2020",
      data: [
        {
          id: 1,
          name: "Engineering ID",
          code: "IR–E–C–17955",
          // link: "uploads/NIRF/2019-20 NIRF ENGG.pdf",
        },
        {
          id: 2,
          name: "Overall ID",
          code: "IR–O–C–17955",
          // link: "?p=nirf",
        },
      ],
    },
    {
      year: "NIRF 2018-2019",
      data: [
        {
          id: 1,
          name: "Engineering ID",
          code: "IR–E–C–17955",
          // link: "uploads/NIRF/All Report-MHRD, National Institutional Ranking Framework (NIRF) overall.pdf",
        },
        {
          id: 2,
          name: "Overall ID",
          code: "IR–O–C–17955",
          // link: "uploads/NIRF/All Report-MHRD, National Institutional Ranking Framework (NIRF).pdf",
        },
      ],
    },
    {
      year: "NIRF 2017-2018",
      data: [
        {
          id: 1,
          name: "Engineering ID",
          code: "IR–E–C–17955",
          // link: "uploads/NIRF/NIRF SUBMITTED DATA-ENGINEERING.pdf",
        },
        {
          id: 2,
          name: "Overall ID",
          code: "IR–O–C–17955",
          // link: "uploads/NIRF/NIRF SUBMITTED DATA-OVERALL.pdf",
        },
      ],
    },
    {
      year: "NIRF 2016-2017",
      data: [
        {
          id: 1,
          name: "Engineering ID",
          code: "IR–E–C–17955",
          // link: "uploads/NIRF/2016 NIRF Engg.pdf",
        },
        {
          id: 2,
          name: "Overall ID",
          code: "IR–O–C–17955",
          // link: "uploads/NIRF/2016 NIRF Overall.pdf",
        },
      ],
    },
  ];

  return (
    <>
      <Header parentMenu="accreditation" menuCategoryEnable="enable" />
      <div class="react-wrapper background_height">
        <div class="react-wrapper-inner background_image">
          <div className="react-breadcrumbs">
            <div className="breadcrumbs-wrap">
              <img className="desktop" src={Banner} alt="Breadcrumbs" />
              <img className="mobile" src={Banner} alt="Breadcrumbs" />
              <div className="breadcrumbs-inner">
                <div className="container">
                  <div className="breadcrumbs-text">
                    <h1 className="breadcrumbs-title">NIRF</h1>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="high_quality-section pt---60 pb---120">
            <div class="container ">
              <SideManu />
              <div class="row m-0">
                <div
                  class="col-md-12  col-sm-12 col-12 bg_color"
                  style={{ backgroundColor: "#fff" }}
                >
                  <br />
                  <div class="container">
                    {/* <div class="table-responsive table-bordered table-striped ">
                                            <table class="table responsive">
                                                <thead>
                                                    <tr>
                                                        <th style={{ backgroundColor: "#00428a", color: '#fff', textAlign: "center",width: '4%' }}>S.No</th>
                                                        <th style={{ backgroundColor: "#00428a", color: '#fff', textAlign: "center", width: '25%' }}>NIRF 2024-2025</th>

                                                        <th style={{ backgroundColor: "#00428a", color: '#fff', textAlign: "center", width: '45%' }}>view</th>
                                                        <th style={{ backgroundColor: "#00428a", color: '#fff', textAlign: "center", width: '26%' }}>Download</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <tr>
                                                        <td style={{ textAlign: 'center',verticalAlign: 'middle' }}>1</td>
                                                        <td style={{ verticalAlign: 'middle' }}>Engineering - IR-E-C-17955</td>
                                                        <td style={{ textAlign: 'center',verticalAlign: 'middle' }}>view</td>
                                                        <td style={{ textAlign: 'center',verticalAlign: 'middle' }}>Download</td>
                                                    </tr>
                                                    <tr>
                                                        <td style={{ textAlign: 'center',verticalAlign: 'middle' }}>2</td>
                                                        <td style={{ verticalAlign: 'middle' }}>Overall - IR-O-C-17955</td>
                                                        <td style={{ textAlign: 'center',verticalAlign: 'middle' }}>view</td>
                                                        <td style={{ textAlign: 'center',verticalAlign: 'middle' }}>Download</td>
                                                    </tr>
                                                    <tr>
                                                        <td style={{ textAlign: 'center',verticalAlign: 'middle' }}>3</td>
                                                        <td style={{ verticalAlign: 'middle' }}>Innovation-IR-I-C-17955</td>
                                                        <td style={{ textAlign: 'center',verticalAlign: 'middle' }}>view</td>
                                                        <td style={{ textAlign: 'center',verticalAlign: 'middle' }}>Download</td>
                                                    </tr>
                                                    <tr>
                                                        <td style={{ textAlign: 'center',verticalAlign: 'middle' }}>4</td>
                                                        <td style={{ verticalAlign: 'middle' }}>SDG-IR-B-C-17955</td>
                                                        <td style={{ textAlign: 'center',verticalAlign: 'middle' }}>view</td>
                                                        <td style={{ textAlign: 'center',verticalAlign: 'middle' }}>Download</td>
                                                    </tr>
                                                    
                                                </tbody>
                                            </table>
                                        </div> */}

                    <center>
                      <img
                        src={NIRFIMAGE}
                        alt="NABL Accredited"
                        style={{ width: "80%" }}
                      ></img>
                    </center>
                    <div className="row mt-5">
                      <h2 className="text-divider text-center">
                        <span
                          style={{
                            backgroundColor: "#fd803d",
                            color: "#fff",
                            padding: "5px 15px",
                            borderRadius: "5px",
                            fontSize: "clamp(14px, 2.5vw, 28px)", // responsive
                            display: "inline-block",
                            textAlign: "center",
                          }}
                        >
                          NATIONAL INSTITUTIONAL RANKING FRAMEWORK (NIRF)
                        </span>
                      </h2>
                    </div>
                    <div className="text-justify lab-text tab_content">
                      {/* <div className="row">
                                                <h4 className="text-divider text-center visible-xs visible-sm">
                                                <span id="font">
                                                    Institute Name : Aditya Engineering College
                                                </span>
                                                </h4>
                                            </div> */}

                      <div className="table-responsive">
                        <table className="table table-bordered table-hover table-striped">
                          {nirfData.map((section, index) => (
                            <React.Fragment key={index}>
                              <thead>
                                <tr
                                  className="course_head"
                                  style={{
                                    backgroundColor: "#00428a",
                                    color: "#fff",
                                  }}
                                >
                                  <th className="text-center">S.No</th>
                                  <th colSpan="2" className="text-center">
                                    {section.year}
                                  </th>
                                  <th className="text-center">View</th>
                                  <th className="text-center">Download</th>
                                </tr>
                              </thead>

                              <tbody>
                                {section.data.map((item) => (
                                  <tr key={item.id}>
                                    <td className="text-center">{item.id}</td>
                                    <td>{item.name}</td>
                                    <td>{item.code}</td>

                                    <td className="text-center">
                                      <a href={item.link} rel="noreferrer">
                                        <i className="fa-solid fa-eye"></i> View
                                      </a>
                                    </td>

                                    <td className="text-center">
                                      <a
                                        href={item.link}
                                        download
                                        rel="noreferrer"
                                      >
                                        <i className="fa-solid fa-download"></i>{" "}
                                        Download
                                      </a>
                                    </td>
                                  </tr>
                                ))}
                              </tbody>
                            </React.Fragment>
                          ))}
                        </table>
                      </div>
                      <p
                        style={{
                          marginTop: "20px",
                          fontSize: "15px",
                          color: "#555",
                          textAlign: "center",
                          lineHeight: "1.6",
                        }}
                      >
                        Comments and feedback may be sent to{" "}
                        <a
                          href="mailto:dean_iqac@adityauniversity.in"
                          style={{
                            color: "#00428a",
                            fontWeight: "600",
                            textDecoration: "none",
                          }}
                          onMouseOver={(e) =>
                            (e.target.style.textDecoration = "underline")
                          }
                          onMouseOut={(e) =>
                            (e.target.style.textDecoration = "none")
                          }
                        >
                          dean_iqac@adityauniversity.in
                        </a>
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <ScrollToTop />
        </div>
      </div>
      <FooterTwo />
    </>
  );
};

export default diploma_programs;
